import { simpleGlobalState } from '@pbk-web/state';
import type { FormType, ModuleTemplate } from '@pbk-web/types';

import type { ClientFormTag, ClientFormUser } from '../models/ClientFormUser';
import { VersionState } from '../models/ClientFormVersionHistory';

type ActivityCommentsStats = {
  clientFormId: string;
  unreadCommentsCount: number;
  sectionCommentsCounts: Record<string, number>;
  actionCommentsCounts: Record<string, number>;
};

export const useCurrentFormType = simpleGlobalState<(typeof FormType)[keyof typeof FormType] | null>(null);

export const useCurrentFormIsTemplate = simpleGlobalState<boolean | null>(null);

export const useCurrentFormVersionState = simpleGlobalState<VersionState>(VersionState.Draft);

export const useCurrentActivityCommentsStats = simpleGlobalState<ActivityCommentsStats>({
  clientFormId: '',
  unreadCommentsCount: 0,
  sectionCommentsCounts: {},
  actionCommentsCounts: {},
});

export const useCurrentFormUsers = simpleGlobalState<ClientFormUser[]>([]);

export const useFormSectionUsers = simpleGlobalState<ClientFormUser[]>([]);

/**
 * @deprecated Criteria access-policy members are now projected into `useCurrentFormUsers` /
 * `useFormSectionUsers` (flagged `fromCriteria`) for permission, membership and display checks.
 * This form-user tag store is retained only to feed the legacy criteria editor and should be
 * removed once that editor no longer relies on the ClientFormTag representation.
 */
export const useClientFormUserTags = simpleGlobalState<ClientFormTag[]>([]);

export const useFormCompletedSections = simpleGlobalState<Record<string, boolean>>({});

export const useHidePrivateComments = simpleGlobalState(false);

export const useViewDistributionLogs = simpleGlobalState(false);

export { useViewDocumentTrainingRecords } from '@pbk-web/state';

export const useInlineAnswerHistory = simpleGlobalState(false);

export const useCurrentFormModule = simpleGlobalState<ModuleTemplate | null>(null);
